import React, { useContext, useEffect, useState,useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import axios from 'axios';
import { AuthContext } from './../AuthContext';
import { parseStoredAccessToken } from '../parseStoredAccessToken.js';
import { site_url, site_url_img } from "./../config.js";
import './style.css';
import "./../Signin/LoginPage.css";

export default function MPINPage({ onSubmit }) {
  const [pin, setPin] = useState(["", "", "", ""]);
  const [mode, setMode] = useState("verify"); // or "set"
  const inputs = useRef([]);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, fulluser } = useContext(AuthContext);

  useEffect(() => {
    // Remove modal backdrops
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((el) => el.remove());

    // Remove modal-open class
    document.body.classList.remove("modal-open");

    // Remove inline styles like overflow and padding
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";

    // Optionally, clear all inline styles (use with caution)
    // document.body.removeAttribute("style");
  }, [location]);
  useEffect(() => {
    const savedMPIN = localStorage.getItem("mpin");
    const isVerified = sessionStorage.getItem("mpin_verified") === "true";

    if (isVerified) {
       navigate("/");
      setMode("verify");
    } else if (!savedMPIN) {
      setMode("set");
    } else {
      setMode("verify");
    }

    inputs.current[0]?.focus();
  }, [navigate]);

  const handleChange = (value, index) => {
    if (/^\d$/.test(value)) {
      const newPin = [...pin];
      newPin[index] = value;
      setPin(newPin);
      if (index < 3) inputs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newPin = [...pin];
      if (pin[index] === "") {
        if (index > 0) {
          inputs.current[index - 1]?.focus();
          newPin[index - 1] = "";
        }
      } else {
        newPin[index] = "";
      }
      setPin(newPin);
    }
  };

  const handleSubmit = () => {
    const enteredPin = pin.join("");
    if (enteredPin.length !== 4) {
      alert("Please enter a 4-digit MPIN.");
      return;
    }

    if (mode === "set") {
      localStorage.setItem("mpin", enteredPin);
      sessionStorage.setItem("mpin_verified", "true");
      const token = parseStoredAccessToken(user);

      axios.post(site_url + "/setmpin", {
        mpin:enteredPin
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
      .then(res => {
        if (res.data.status) {
           navigate("/home");

           alert("MPIN set successfully!");
      onSubmit?.(enteredPin);
      navigate("/");


        }
      })
      .catch(err => {
        console.error("API Error:", err.response?.data || err.message);
      });
      


     
    } else if (mode === "verify") {
      const saved = localStorage.getItem("mpin");
      if (enteredPin === saved) {
        sessionStorage.setItem("mpin_verified", "true");
        onSubmit?.(enteredPin);
        navigate("/");
      } else {
        alert("Incorrect MPIN.");
      }
    }
  };

  const handleReset = () => {
    const userConfirmed = window.confirm("Reset MPIN? Enter your password.");
    if (userConfirmed) {
      const userPassword = prompt("Enter your user password:");

      const token = parseStoredAccessToken(user);

      axios.post(site_url + "/resetmpin", {
        mpin:userPassword
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
      .then(res => {
        if (res.data.status == 'success') {
          localStorage.removeItem("mpin");
          sessionStorage.removeItem("mpin_verified");
          setPin(["", "", "", ""]);
          setMode("set");
          inputs.current[0]?.focus();


        }else{
          alert("Wrong password.");
        }
      })
      .catch(err => {
        console.error("API Error:", err.response?.data || err.message);
      });


      
    }
  };

  return (
    <div className="login-container">
    <div className="login-header">
      <img
        src="digital-marketing.jpg" // Replace with your truck image URL
        alt="Truck"
        className="header-image"
      />
    </div>
    <div className="login-form">
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ width: "100%" }}
    >
      <div
        style={{ width: "90%" }}
        className="d-flex flex-column align-items-center gap-3 p-4  "
      >
        {/* <img src="./app_logo.png" alt="Logo" style={{ height: "250px" }} /> */}
        <h2 style={{ fontWeight: "700", color: "#00695c" }}>
          {mode === "set" ? "Set MPIN" : "Enter MPIN"}
        </h2>

        <div className="d-flex gap-2">
          {pin.map((digit, idx) => (
            <input
              key={idx}
              type="password"
              maxLength="1"
              value={digit}
              onChange={(e) => handleChange(e.target.value, idx)}
              onKeyDown={(e) => handleKeyDown(e, idx)}
              ref={(el) => (inputs.current[idx] = el)}
              className="form-control text-center"
              style={{ width: "50px", height: "50px", fontSize: "24px" }}
            />
          ))}
        </div>

        <button onClick={handleSubmit} className="btn btn-primary px-4 mt-2">
          {mode === "set" ? "Set MPIN" : "Submit"}
        </button>

        {mode === "verify" && (
          <a onClick={handleReset} style={{fontWeight:'500'}} className=" text-black mt-2">
            Reset MPIN
          </a>
        )}
      </div>
      </div>
      </div>
    </div>
  );
}
